import {useEffect} from 'react';
import Wrapper from './Wrapper';
import {useHelpContext} from './Provider';

const HelpWrapper = Wrapper;
export default HelpWrapper;

const scrollDirection = {
    UP: 'up',
    DOWN: 'down',
    TOP: 'top',
};

const useScroll = (callback) => {
    const {scrollHook} = useHelpContext();

    useEffect(() => {
        return scrollHook.listen(callback);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrollHook]);
}

export {
    useHelpContext as useHelp,
    useScroll,
    scrollDirection,
}
